

import React, { useEffect, useRef, useState } from "react";
import { Card, Box, Avatar, Typography, Button, Modal, CircularProgress, useTheme, useMediaQuery, Autocomplete } from "@mui/material";
import { DecorativeCorner } from "../../common/DecorativeCorner";
import { useNavigate } from "react-router-dom";
import { FormControl, MenuItem, Select, TextField } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { matrimoneyEndPoints } from "../../../services/apis";
import { FontStyles } from "../../styles/FontStyles";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Badge } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import VerifiedIcon from "@mui/icons-material/Verified";
import EmailIcon from "@mui/icons-material/Email";
import documneticon from "../../common/01.png";
// import MailCheckmark from '../../common/02.png';
// import verifymoblieicon from '../../common/03.png';
import ProfileAutoScrollCard from "./carouselComponent";

import MobileVerified from '../../common/mobile-verified.png'
import MobileNotVerified from '../../common/mobile-not-verified.png'
import IdentityVerified from '../../common/identity-verified.png'
import IdentityNotVerified from '../../common/identity-not-verified.png'
import MailVerified from '../../common/mail-verified.png'
import MailNotVerified from '../../common/mail-not-verified.png'
import { StyledTextField } from "../../common/FormStyles";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { fetchCastesByReligionId } from "../../../services/operations/userOperations";
import { showError, showSuccess } from "./sweetAlert/sweetAlert";
const delayOptions = [
  { id: 0, name: "Immediately" },
  { id: 1440, name: "After 1 Day" },
  { id: 2880, name: "After 2 Days" },
  { id: 4320, name: "After 3 Days" },
];

const defaultOption = delayOptions.find((opt) => opt.id === 2880); // "After 2 Days"
const DetaliesDashbord = () => {
     const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [tempSelection, setTempSelection] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSelectChange = (event, newValue) => {
    if (newValue && newValue.id !== selectedOption.id) {
      setTempSelection(newValue);
      setShowConfirm(true);
    }
  };
 const updateContactRevealTime = async (formData) => {
	try {
		
		const response = await axios.post(
			matrimoneyEndPoints.AUTO_REVEAL_SETTINGS,
			formData,
			{
				headers: {
					Authorization: `Bearer ${sessionStorage.getItem("userType") ? sessionStorage.getItem("token") : localStorage.getItem("token")}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		return {
			status: false,
			message:
				error.response?.data?.message || "Failed to update education details",
		};
	}
};
  const handleConfirm = async() => {
    setSelectedOption(tempSelection);
            try {
                const response = await updateContactRevealTime({autoRevealContactTimeInMin : tempSelection?.id})
                if (response.status) {
                    setShowConfirm(false);
                    showSuccess(response?.message)

                }else{
                    showError(response?.message)
                }
            } catch (error) {
                 showError(error.message)
                console.error("Error fetching castes:", error);
            }

    // ✅ Send selected ID to API
    console.log("Send to API:", tempSelection.id);
    // callYourApi(tempSelection.id);
  };
  const handleCancel = () => {
    setTempSelection(null);
    setShowConfirm(false);
  };
    const dummyProfiles = [
        {
            name: "Alice",
            age: 30,
            income: "$70,000",
            image: "https://randomuser.me/api/portraits/women/44.jpg",
        },
        {
            name: "Bob",
            age: 34,
            income: "$90,000",
            image: "https://randomuser.me/api/portraits/women/65.jpg",
        },
        {
            name: "Charlie",
            age: 29,
            income: "$65,000",
            image: "https://randomuser.me/api/portraits/women/12.jpg",
        },
    ];
    const [open, setOpen] = useState(false);

    const handleProfileClick = (profile) => {
        console.log("Profile clicked:", profile);
        // You can navigate or pass data to another component here
        setOpen(false);
    };
    const navigate = useNavigate();
    const [popup, setPopup] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState("");
    const [selectage, setSelectAge] = useState("");
    const profile = localStorage.getItem("profileData");
    const storedProfileData = JSON.parse(profile)
    const apiCall = useRef(false)
    const [profileCaradData, setProfileCardData] = useState({})
    const [premiumProfileData, setPremiumProfileData] = useState({})
    const [profilestranth, setProfileStrength] = useState([])
    let userType = sessionStorage.getItem("userType")
    let token
    if (userType) {
        token = sessionStorage.getItem("token");
    } else {
        token = localStorage.getItem("token");
    }
    // debugger
    const profileCardData = async () => {
        try {
            const response = await axios.post(
                matrimoneyEndPoints.MY_PROFILE_CARD,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status) {
                setProfileCardData(response.data?.data);
                setProfileStrength(response.data)
            } else {
                setProfileCardData([])
            }
        } catch (error) {
            console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
        }
    }
      const getPremiumProfileCardData = async () => {
        try {
            const response = await axios.post(
                matrimoneyEndPoints.PREMIUM_PROFILES_DATA,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.status) {
                setPremiumProfileData(response.data?.data);
            } else {
                setPremiumProfileData([])
            }
        } catch (error) {
            console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
        }
    }
    useEffect(() => {
        if (!apiCall.current) {
            apiCall.current = true
            profileCardData()
            getPremiumProfileCardData()
        }
    })
    const handleChange = (event) => {
        setSelectedDetail(event.target.value);
    };
    const handleSelectAge = (e) => {
        setSelectAge(e.target.value)
    }
    const handlechangeReset = (e) => {
        setSelectedDetail(false);
        setSelectAge(false);
    }

    const theme = useTheme();

    const isXs = useMediaQuery(theme.breakpoints.only("xs"));
    const isSm = useMediaQuery(theme.breakpoints.only("sm"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isXll = useMediaQuery(theme.breakpoints.up("xxl"));
    let progressSize = 500;
    if (isXs) progressSize = 200;
    else if (isSm) progressSize = 120;
    else if (isMd) progressSize = 120;
    else if (isLg) progressSize = 200;
    else if (isXl) progressSize = 200;
    // if (isXll) {
    //     console.log("Ultra-wide screen: 1920px or more");
    //   }
    else if (isXll) progressSize = 350;
    const marginLeftValue = profileCaradData && profileCaradData.planStatus !== 0 ? "2%" : 0;
const imagevalue= profileCaradData && profileCaradData.planStatus !== 0 ? "20%" : 0;
const scrollimage=profileCaradData && profileCaradData.planStatus !== 0 ? "20%" : 0;
const fontsize=profileCaradData && profileCaradData.planStatus !== 0 ? "15px" : 0;

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    height: "auto",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: { xs: "column", sm: "column", md: 'column', lg: "row", xl: "row", xxl: "row" },
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                    width: { xs: "100%", sm: "100%" },
                    // marginTop: { xs: "20%", sm: "6.5%" },
                    marginTop: { xs: "20%", sm: "6.5%", md: "6.5%", lg: "6.5%", xl: "5.5%", xxl: "5.5%", },
                    padding: "0px"
                }}
            >
                <Card
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        padding: { xs: "20px 10px", sm: "0px" },
                        width: "100%",
                        flexDirection: { xs: "column", sm: "column", md: 'column', lg: "row", xl: "row", xll: "row" },
                        textAlign: { xs: "center", sm: "left" },
                        position: "relative",
                        boxShadow: "none",
                        borderLeft: "none",
                        borderRight: "none"
                    }}
                >
                    <DecorativeCorner sx={{
                        top: { xs: -10, sm: -20 },
                        left: { xs: -10, sm: -20 },
                        width: { xs: "60px", sm: "100px" },
                        height: { xs: "60px", sm: "100px" }
                    }} />
                    <DecorativeCorner sx={{
                        bottom: { xs: -10, sm: -20 },
                        right: { xs: -10, sm: -20 },
                        width: { xs: "60px", sm: "100px" },
                        height: { xs: "60px", sm: "100px" }
                    }} />

                    <Box
                        component="img"
                        src="/images/mandala.png"
                        alt="Background"
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: { xs: "280px", sm: "250px", md: "250px", lg: "422px", xl: "400px" },
                            opacity: 0.06,//0.04
                            zIndex: 0,
                        }}
                    />
            
                    <Box sx={{ zIndex: 1 }}>
                        <Box
                            sx={{
                                position: "relative",
                                width: { xs: "190px", sm: "150px", md: "220px" },//180
                                height: { xs: "190px", sm: "150px", md: "220px" },//180
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginY: { md: "5%", sm: "50%", xs: "20px" },
                                marginLeft: { sm: "20%", md: "5%", xl: imagevalue},

                            }}
                        >
                            <CircularProgress
                                variant="determinate"
                                value={100}
                                size={180}
                                thickness={2}
                                sx={{
                                    position: "absolute",
                                    color: "#F0E0D0",
                                }}
                            />
                            <CircularProgress
                                variant="determinate"
                                value={80}
                                size={180}
                                thickness={2}
                                sx={{
                                    position: "absolute",
                                    color: "#c1721f",
                                }}
                            />
                            <Box
                                component="img"
                                src={profileCaradData?.profileImage || "/images/men.jpeg"}
                                sx={{
                                    width: "75%",
                                    height: "75%",
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    padding: "5px",
                                    position: "absolute",
                                }}
                            />
                        </Box>
                    </Box>
                    <Box sx={{marginLeft: { sm: marginLeftValue }  }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Typography sx={{ ...FontStyles.profilename }}>
                                {profileCaradData?.name || ""}
                            </Typography>
                            <Typography sx={{ ...FontStyles.cardid,}}>
                                [{profileCaradData?.customerId || ""}]
                            </Typography>
                               <div style={{ width: "200px" }}>
  <Autocomplete
    options={delayOptions}
    getOptionLabel={(option) => option.name}
    value={selectedOption}
    onChange={handleSelectChange}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Contact Reveal Delay"
        variant="outlined"
        size="small"
      />
    )}
  />
</div>

                        </Box>

                        <Box sx={{
                            display: "flex", gap: 1, mt: { xs: 1, sm: 1 }, justifyContent: { xs: "center", sm: "flex-start" }, flexDirection: { xs: "column", sm: "row" },
                        }}>
                            <Button
                                sx={{
                                    ...FontStyles.incomming //plan button remove here
                                }}
                            >
                                {profileCaradData && profileCaradData.planName || ""}
                            </Button>
                            <Button
                                sx={{
                                    ...FontStyles.incomming
                                }}
                            >
                                Out Going ({profileCaradData && profileCaradData.outgoingContactBalance || 0}/{profileCaradData && profileCaradData.planOutgoingContacts || 0})
                            </Button>

                            <Button
                                sx={{
                                    ...FontStyles.incomming
                                }}
                            >
                                In Coming ({profileCaradData && profileCaradData.incomingContactBalance || 0}/{profileCaradData && profileCaradData.planIncomingContacts || 0})
                            </Button>
                        </Box>

                        <Box sx={{
                            display: "flex",
                            gap: 1,
                            mt: { xs: 1.5, sm: 2 },
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: "center",
                        }}>
                            <Button
                                sx={{
                                    ...FontStyles.viewandeditButton
                                }}
                                onClick={() => navigate(`/profile/ProfileView`, { state: { profileId: profileCaradData.id } })}
                            >
                                View & Edit Profile
                            </Button>

                            <Button
                                sx={{
                                    ...FontStyles.invoiceButton
                                }}
                            >
                                Download Invoice
                            </Button>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box
                                    component="img"
                                    src={profileCaradData?.mobileVerification == 1 ? MobileVerified : MobileNotVerified}
                                    alt="Document Icon"
                                    sx={{ width: "50px", height: "50px", mb: "-5px" }}
                                />
                                <Box
                                    component="img"
                                    src={profileCaradData?.emailVerification == 1 ? MailVerified : MailNotVerified}
                                    alt="Document Icon"
                                    // sx={{ width:  "40px", height: "53px",mb:"-5px"  }}
                                    sx={{ width: "50px", height: "50px", mb: "-5px" }}

                                />
                                <Box
                                    component="img"
                                    src={profileCaradData?.documentVerification == 1 ? IdentityVerified : IdentityNotVerified}
                                    alt="Document Icon"
                                    // sx={{ width:  "40px", height: "35px",mb:"-0px"  }}
                                    sx={{ width: "50px", height: "50px", mb: "-5px" }}

                                />
                                {/* <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}
                                    badgeContent={
                                        <VerifiedIcon fontSize="small" sx={{ color: "red" }} />
                                    }
                                >
                                    <DescriptionIcon />
                                </Badge>
                            </Box>
                            <Box display="flex" alignItems="center" gap={0.5} sx={{boder:"2px solid #ccc"}}>
                                <PhoneIphoneIcon color="black" />
                                <VerifiedIcon color="success" fontSize="small" sx={{ marginLeft: { xs: "auto", md: "-35%" }, marginTop: { xs: "auto", md: "15px" } }} />
                            </Box>
                            <Box display="flex" alignItems="center" gap={0.5} sx={{ marginLeft: "-5%" }}>
                                <EmailIcon color="black" />
                              
                            <VerifiedIcon color="success" fontSize="small" sx={{ marginLeft: { xs: "auto", md: "-35%" }, marginTop: { xs: "auto", md: "15px" } }} /></Box> */}
                            </Box>
                        </Box>
                    </Box>
                    <Box className="card" sx={{ display: "flex",flexDirection: { xs: "column", md: "row" }, // column on xs, row on md+
    alignItems: "center", 
    justifyContent: "center",  }}>
                        <Box sx={{ marginTop: "-20px" ,marginLeft:scrollimage}}>
                            <ProfileAutoScrollCard profiles={premiumProfileData} />

                        </Box>
                        {(profileCaradData && profileCaradData.planStatus != 1) && <Box
                            sx={{
                                position: "relative",
                                // width: { xs: "100%", sm: "250px", md: "380px" },
                                width: { xs: "100%", sm: "350px", md: "380px", lg: "422px", xl: "380px", xxl: "900px" },
                                height: { xs: "auto", sm: "190px", md: "190px", xl: "190px", xxl: "350px" },
                                borderRadius: "32px",
                                display: "flex",
                                top: "20px",
                                left: "20px",
                                justifyContent: "center",
                                alignItems: "center",
                                border: "2px solid #c1721f",
                                padding: { xs: "15px", sm: "5px 15px" },
                                // marginLeft: { sm: "0px", md: "10%", lg: "10%", xl: "0%", xxl: "10%" },
                                marginRight: { xs: "30px" },
                                marginBottom: { xs: "60px" },
                                marginTop: "10px"
                            }}
                        >
                            <Card
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: { xs: "15px", sm: "0px", md: "20px" },
                                    borderRadius: "24px",
                                    border: "#F7F4F1",
                                    backgroundColor: "#FAF3E0",
                                    width: { xs: "100%", sm: "280px", md: "380px", lg: "422px", xl: "380px", xxl: "700px" },
                                    height: { sm: "150px", md: "150px", lg: "150px", xl: "150px", xxl: "280px" },
                                    top: "20px",
                                    left: "20px",
                                    textAlign: "center",
                                }}
                            >
                                <Typography sx={{
                                    ...FontStyles.paytext
                                }}>
                                    Upgrade membership to <br />
                                    call/chat with matches                    </Typography>
                                <Button
                                    sx={{
                                        ...FontStyles.payButton
                                    }}
                                    onClick={() => navigate("/profile/payment")}
                                >
                                    Upgrade Now
                                </Button>
                            </Card>
                            <Modal open={popup} onClose={() => setPopup(false)}>
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: { xs: "90%", sm: "50%" },
                                        bgcolor: "white",
                                        boxShadow: 24,
                                        p: 3,
                                        borderRadius: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                    }}
                                >
                                    <Box sx={{
                                        display: "flex", alignItems: "center", justifyContent: "space-between", gap: "10px"
                                    }}>
                                        <Button onClick={() => setPopup(false)} sx={{ minWidth: "auto", padding: 0 }}>
                                            <ArrowBackIcon sx={{ color: "black" }} />
                                        </Button>
                                        <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
                                            Select Your Details
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        <FormControl sx={{ width: 500 }}>
                                            <TextField
                                                value={selectedDetail}
                                                onChange={handleChange}
                                                placeholder="Rohith Kumar"
                                            />
                                        </FormControl>

                                        <FormControl sx={{ width: 500 }}>
                                            <TextField
                                                value={selectage}
                                                onChange={handleSelectAge}
                                                placeholder="AM100491"
                                            />
                                        </FormControl>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: "10px"
                                        }}
                                    >
                                        <Button
                                            onClick={handlechangeReset}
                                            sx={{
                                                backgroundColor: "white",
                                                color: "#B56E2C",
                                                padding: "10px",
                                                width: "111px",
                                                fontSize: { xs: "13px", sm: "16px" },
                                                "&:hover": { backgroundColor: "#8E5723", color: "#fff" },
                                                borderRadius: "20px",
                                                border: "2px solid #B56E2C"
                                            }}
                                        >
                                            Reset
                                        </Button>

                                        <Button
                                            sx={{
                                                backgroundColor: "#B56E2C",
                                                color: "white",
                                                padding: "10px",
                                                width: "111px",
                                                fontSize: { xs: "13px", sm: "16px" },
                                                "&:hover": { backgroundColor: "#8E5723" },
                                                borderRadius: "20px"
                                            }}
                                            onClick={() => setPopup(false)}
                                        >
                                            Edit Now
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </Box>}
                    </Box>


                </Card>

            </Box>
           
<Dialog open={showConfirm} onClose={handleCancel}>
  <DialogTitle>Confirm Change</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Are you sure you want to change the contact reveal time?
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCancel} color="secondary">
      Cancel
    </Button>
    <Button onClick={handleConfirm} color="primary" autoFocus>
      OK
    </Button>
  </DialogActions>
</Dialog>
        </>
    );
};

export default DetaliesDashbord;
